var common = require("../utiles/common")
var Cookies = require("js-cookie");

module.exports = {
    register: function () {
        document.createElement('language')
        ko.components.register('language', {
            viewModel: function (params) {
                var $this = this;
                $this.type = params.type?params.type:"default";
                $this.lan = Cookies.get("language")?Cookies.get("language"):"zh_CN";
                $this.setLanguage = function(v){
                    var value = $("#languageValue").val();
                    console.log(value)
                    var v = value == "zh_CN"?0:1;
                    common.fetch("/auth/set?language="+v, {
                        type: "GET"
                    }).data
                    window.location.reload();
                }
            },
            template: require("./Language.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/template/Language.js
// module id = 91
// module chunks = 0